module.exports = __webpack_public_path__ + "static/media/รายงานเยี่ยมบ้าน.66382f18.xls";